export type UiGameConfig = {
  levelNames: Record<string, string>
}

const prefix = 'dropee.v1.'
export const isDropeeStorageKey = (key: string) => key.startsWith(prefix)
export const buildDropeeStorageKey = (key: string) => `${prefix}${key}`
